import entitysType from "../../enums/entitysType";
import tags from "../../enums/tags";
import loadScript from "../../utils/loadScript";
import { fetchGetAuth, postForm, postJson } from "../../utils/utils";
import { authActions } from "./auth-slice";
import { entitiesActions } from "./entities-slice";
import { fetchSchoolToolsThunk } from "./tool-actions";

const loadAuthGlobalSettings = async () => {
    if (window.config.tabsConfig)
        return;
    await loadScript(window.config.authSettings);
};

const fetchAndMergeSchoolData = async (dispatch, schoolId) => {
    if (!schoolId) return;
    const result = await postJson(`${window.config.baseApiUrl}/api/school/getSchoolInfo?schoolId=${schoolId}`);
    if (result?.ok && result.body) {
        dispatch(authActions.mergeDefaultSchoolData(result.body));
    }
};

export const login = () => {
    window.location.href = `${window.config.authApiUrl}/auth/eduidp?next=${window.location.href}`;
}

export const checkLogin = () => {
    return async (dispatch) => {
        try {
            let res = await fetch(`${window.config.baseApiUrl}/auth/my`, {
                credentials: "include"
            })
            let data = await res.json();
            if (data.isAuth) {
                try {
                    await loadAuthGlobalSettings();
                }
                catch (e) {
                    console.error(e);
                }
            }
            dispatch(authActions.init(data))
            if (data.isAuth)
                dispatch(getUserDetails())

        }
        catch {
            dispatch(authActions.init({ isAuth: false }))
        }
    }
}


export const getUserDetails = () => {
    return async (dispatch) => {
        try {
            let resUserFilter = await fetchGetAuth(`${window.config.baseApiUrl}/api/user/filter?getMainClass=true`);
            if (resUserFilter) {
                dispatch(authActions.setUserDetails(resUserFilter))
                const schoolId = Number(localStorage.getItem("selectedSchoolId"));
                const selectedSchool = resUserFilter?.schools?.find(s => Number(s.id) === schoolId) || resUserFilter?.schools?.[0];
                const defaultSchool = selectedSchool && !resUserFilter.isStudnt ? selectedSchool : resUserFilter?.defaultSchool;
                dispatch(authActions.setDefaultSchool(defaultSchool));
                dispatch(fetchSchoolToolsThunk(defaultSchool?.id));
                await fetchAndMergeSchoolData(dispatch, defaultSchool?.id);
            }
            else
                dispatch(authActions.setUserDetails({ genderId: 0 }))
        }
        catch {
            dispatch(authActions.init({ isAuth: false }))
        }
    }
}

export const logout = (exidentifier) => {
    if (exidentifier) {
        localStorage.removeItem(`teacher-image-popup_${exidentifier}`);
    }
    window.location.href = `${window.config.baseApiUrl}/auth/logout?next=${window.location.origin}${window.config.baseUrl}/`;
}

export const changeSchool = (school) => {
    return async (dispatch) => {
        try {
            localStorage.setItem('selectedSchoolId', school.id);
            dispatch(authActions.setDefaultSchool(school));
            dispatch(entitiesActions.clearEntitiesByType({ type: entitysType.message }));
            dispatch(entitiesActions.clearEntitiesByType({ type: entitysType.usefulTool, tag: tags.addedByUser }));
            dispatch(fetchSchoolToolsThunk(school?.id));
            await fetchAndMergeSchoolData(dispatch, school?.id);
        }
        catch { }
    }
}

export const saveSchoolDataThunk = (formData) => async (dispatch) => {
    try {
        dispatch(authActions.setLoading(true));
        const result = await postForm(`${window.config.baseApiUrl}/api/school/addOrUpdate`, formData);
        if (result?.ok && result.body) {
            dispatch(authActions.mergeDefaultSchoolData(result.body));
        }
        return result?.ok ? result.body : null;
    } catch (e) {
        console.error("error saveSchoolDataThunk", e);
        return null;
    } finally {
        dispatch(authActions.setLoading(false));
    }
};
